export default {
    "types": {
        "library": {
            "showName": "Библиотека целей"
        }
    },
    "use_scales_units_library": true,
    "element_change_propagation_mode": 2,
    "folder_moderators_config_enabled": false,
    "folder_visibility_config_enabled": true,
    "folder_visibility_config_mode": 1,
    "folder_visibility_config_see_child": true,
    "on_import_using_visible": true,
    "on_folder_clone_clear_fields": [
        "bonus",
        "scale.fact"
    ],
    "elements_table_columns": [
        {
            "label": "ID",
            "prop": "id",
            "width": 70
        },
        {
            "label": "Наименование цели",
            "prop": "name",
            "template": "components/tableColumnTemplates/library/ElementNameTableColumn",
            "bind": {
                "scope": "scope",
                "show-folders-in-search": "templateData.$parent.$parent.$data.showFoldersInSearch"
            }
        },
        {
            "label": "Единица измерения",
            "prop": "scale.unit",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Выше ожиданий",
            "prop": "scale.expectation_above",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Соответствует ожиданиям",
            "prop": "scale.expectation_equal",
            "bind": {
                "scope": "scope"
            }
        },
        {
            "label": "Частично соответствует ожиданиям",
            "prop": "scale.expectation_partial",
            "bind": {
                "scope": "scope"
            }
        }
    ]
}